import pdfjsPkg from 'pdfjs-dist/package.json';
export const PDF_WORKER_URL = `https://unpkg.com/pdfjs-dist@${pdfjsPkg.version}/build/pdf.worker.min.js`;
